import { GET_STATIC_PAGES } from '../constants/staticPages';
import { defaultGetAction } from '../utils/redux';

export const loadStaticPages = defaultGetAction(GET_STATIC_PAGES, 'staticpages/');



// WEBPACK FOOTER //
// ./src/actions/staticPages.js